import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $insertNodes, COMMAND_PRIORITY_EDITOR, createCommand } from 'lexical';
import { useEffect } from 'react';

import { $createEmojiNode } from '../Nodes/EmojiNode';

export const INSERT_EMOJI_COMMAND = createCommand('INSERT_EMOJI_COMMAND');

const EmojiPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const cleanup = editor.registerCommand(
      INSERT_EMOJI_COMMAND,
      (payload) => {
        editor.update(() => {
          const node = $createEmojiNode(payload);

          $insertNodes([node]);
        });

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );

    return () => {
      cleanup();
    };
  }, [editor]);

  return null;
};

export default EmojiPlugin;
